export default "__VITE_ASSET__DEjB6zab__"